import intermind from '../../index';
import { PromptResource } from './resources/prompt';
import { AIMessage } from './types/message.types';

export class AIResource {
  private readonly promptResource: PromptResource;

  constructor() {
    this.promptResource = new PromptResource();
  }

  get prompts() {
    return this.promptResource;
  }

  async sendMessage(conferenceId: string, aiModel: string, message: string): Promise<void> {
    await intermind.httpClient.post(`/ai/messages`, { conferenceId, aiModel, text: message });
  }

  async listMessages(roomId: string): Promise<AIMessage[]> {
    const { data } = await intermind.httpClient.get<AIMessage[]>(`/ai/messages?roomId=${roomId}`);
    return data;
  }

  async listModels(): Promise<string[]> {
    const { data } = await intermind.httpClient.get<string[]>(`/ai/models`);
    return data;
  }
}
